import {createContext, useState} from 'react';

export const NetworkGraphContext = createContext({});

export const NetworkGraphContextProvider = ({children}) => {
  const [cyto, setCyto] = useState();

  return <NetworkGraphContext.Provider value={{cyto, setCyto}}>{children}</NetworkGraphContext.Provider>;
};
